export const INVITATION_TO_PROJECT = 'INVITATION_TO_PROJECT'
export const INVITATION_TO_MODELS = 'INVITATION_TO_MODELS'
